import styled from "styled-components";
import {
    BrowseFileButton,
    PortalMetricCard,
    portalColors
} from "src/components";

export const PhoneContainer = styled.div`
    align-items: start;
    display: flex;
    flex-shrink: 0;
    margin-top: 1rem;
    width: 45%;
    max-width: 45%;
    min-width: 350px;
    justify-content: center;
    margin-left: 0;

    @media (max-width: 900px) {
        max-width: 100%;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
`;

export const InfoText = styled.div`
    margin-top: -0.7em;
    text-align: left;
    font: normal normal normal 15px/21px Manrope;
    letter-spacing: 0px;
    color: #8E4EB4;
    margin-bottom: 1em;
`;

export const IconsCard = styled.div`
    width: auto;
    background: ${portalColors.surface};
    box-shadow: none;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(3, 44px);
    gap: 0.6rem;
    padding: 0.75rem;
    margin-bottom: 0;
    align-content: center; 
    justify-content: start;

    @media (max-width: 768px) {
        grid-template-columns: repeat(4, 44px);
    }
`;


export const IconSlot = styled.div`
    width: 44px;
    height: 44px;
    background: ${p => (p.hasIcon ? "transparent" : "#EBEBEB")};
    border: ${p => (p.hasIcon ? "none" : "2px dashed #D8DEEC")};
    border-radius: 10px;
    position: relative; 
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
    }

    .remove-btn {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 18px;
        height: 18px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px #00000029;
        border: 1px solid #707070;
        border-radius: 50%;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 16px;
        font-weight: bold;

        cursor: pointer;
        z-index: 10;

        line-height: 0;
        padding: 0;
    }
`;

export const IconGroupsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
    gap: 0.75rem;
    align-items: start;
`;

export const IconGroupCard = styled(PortalMetricCard)`
    min-height: auto;
    padding: 0.75rem;
    display: grid;
    gap: 0.6rem;
    align-content: start;
`;

export const AddIconButton = styled(BrowseFileButton)`
    display: inline-flex !important;
    width: 160px !important;
    height: 39px !important;
    background: #171A22 !important;
    box-shadow: 0px 3px 6px #00000029 !important;
    border-radius: 10px !important;
    opacity: 1 !important;
    text-align: center !important;
    font: normal normal medium 14px/16px Manrope !important;
    letter-spacing: 0px !important;
    color: #FFFFFF !important;
    cursor: pointer !important;
    border: none !important;
    align-items: center !important;
    justify-content: center !important;

    &:hover {
        opacity: 0.9 !important;
    }

    input {
        display: none !important;
    }
`;
